import { api } from "../../util";

export const getUsersApiCall = (payload = {}) => {
  let url = "/users/list";

  return api.get(url, {
    params: {
      page: payload.page,
      limit: payload.limit,
      filter: payload.filter || {},
      sort: payload.sort,
      search: payload.search,
    },
  });
};
